import React, { createRef } from "react";
// import Carousel from "react-slick";
import "../../assets/styles/cards.css";

import downArrow from "../../assets/images/keyboard_arrow_up-black.svg";
import upArrow from "../../assets/images/keyboard_arrow_down-black.svg";

import Hammer from "react-hammerjs";
export default class CardList extends React.Component {
  rolodexCards = [];
  selectedCardIndex = 0;
  baseUnit = 10;
  maxNumberOfCreditCards = 3;

  constructor(props) {
    super(props);

    this.myRef = createRef();

    let { cards, selectedCard } = this.props;

    this.rolodexCards = [];

    cards.forEach((val) => {
      this.rolodexCards.push({
        ...val,
        class: "",
        rolodexLayout: { zIndex: null, top: null, width: null },
      });
    });

    this.state = {
      creditCardRolodexMarginTop: "0px",
      rolodexCards: this.rolodexCards,
    };

    this.selectedCardIndex = selectedCard ? cards.indexOf(selectedCard) : 0;
  }

  componentDidMount() {
    this.baseConfig();
    this.setComponentMarginTop();
  }

  // initial config for the cards layout
  baseConfig() {
    let index = this.selectedCardIndex;
    let zIndex = this.rolodexCards.length - 1;

    for (let i = 0; i < this.rolodexCards.length; i++) {
      // last card
      if (index === this.rolodexCards.length) {
        index = 0;
      }

      this.rolodexCards[index].rolodexLayout = {
        zIndex,
        top: `${i * this.baseUnit * -1}%`,
        width: `${100 - i * this.baseUnit}%`,
      };

      index = index + 1;
      zIndex = zIndex - 1;
    }
  }

  // problem: each card is position absolutely so there could be an overlap with outer html elements
  // solution: add margin top accordantly to the number of cards
  setComponentMarginTop() {
    const dsUiCardsRoller = this.myRef.current;

    const paddingTop = window.getComputedStyle(dsUiCardsRoller, null).getPropertyValue("padding-top");
    const numericPaddingTop = parseInt(paddingTop.split("px")[0], 10);
    const numberOfCards = this.rolodexCards.length < this.maxNumberOfCreditCards ? this.rolodexCards.length : this.maxNumberOfCreditCards;

    this.setState({
      creditCardRolodexMarginTop: `${(numericPaddingTop * ((numberOfCards - 1) * this.baseUnit)) / 100}px`,
    });
  }

  //
  selectCard(dir) {
    let selectedCardIndex = this.selectedCardIndex;

    this.setConfig(dir, selectedCardIndex);

    let { onSelectCard } = this.props;
    onSelectCard(this.rolodexCards[this.selectedCardIndex].last4Digits);
  }

  // change the config after user paging the cards
  // right or down - roll previous selected Index
  // left or up - roll current selected Index
  setConfig(order, selectedCardIndex) {
    this.rolodexCards.forEach((card, index) => {
      this.rolodexCards[index].class = "forward-back-animation";
    });

    if (order === "right" || order === "down") {
      let prevIndex = this.selectedCardIndex;
      this.selectedCardIndex = this.selectedCardIndex === this.rolodexCards.length - 1 ? 0 : this.selectedCardIndex + 1;

      // rolodex layouts
      let rolodexLayout = this.rolodexCards[this.rolodexCards.length - 1].rolodexLayout;

      for (let i = this.rolodexCards.length - 1; i > 0; i--) {
        this.rolodexCards[i].rolodexLayout = this.rolodexCards[i - 1].rolodexLayout;
      }

      this.rolodexCards[0].rolodexLayout = rolodexLayout;

      if (this.rolodexCards.length > this.maxNumberOfCreditCards) {
        prevIndex =
          prevIndex + this.maxNumberOfCreditCards < this.rolodexCards.length
            ? prevIndex + this.maxNumberOfCreditCards
            : Math.abs(this.rolodexCards.length - this.maxNumberOfCreditCards - prevIndex);
      }

      this.rolodexCards[prevIndex].class = "roll-animation roll-down-or-right-animation";
    } else {
      this.selectedCardIndex = this.selectedCardIndex === 0 ? this.rolodexCards.length - 1 : this.selectedCardIndex - 1;

      let rolodexLayout = this.rolodexCards[0].rolodexLayout;

      for (let i = 0; i < this.rolodexCards.length - 1; i++) {
        this.rolodexCards[i].rolodexLayout = this.rolodexCards[i + 1].rolodexLayout;
      }

      this.rolodexCards[this.rolodexCards.length - 1].rolodexLayout = rolodexLayout;

      this.rolodexCards[this.selectedCardIndex].class = "roll-animation roll-up-or-left-animation";
    }
  }

  onSwipe(evt) {
    // if there is one card - do nothing
    if (this.rolodexCards.length === 1) {
      return;
    }

    const x = Math.abs(evt.deltaX) > 40 ? (evt.deltaX > 0 ? "right" : "left") : null;
    const y = Math.abs(evt.deltaY) > 40 ? (evt.deltaY > 0 ? "down" : "up") : null;
    const dir = x || y;

    this.selectCard(dir);
  }

  onPagination(dir) {
    this.selectCard(dir);
  }

  hideCard(zIndex) {
    return zIndex >= this.rolodexCards.length - this.maxNumberOfCreditCards;
  }

  render() {
    return (
      <div className="credit-card-rolodex-wrapper">
        <div className="pagination">
          <button
            className="down"
            tooltip="כרטיס הבא"
            onClick={() => {
              this.onPagination("down");
            }}
          >
            <img src={downArrow} alt="" srcSet="" />
          </button>
        </div>

        <div className="credit-card-rolodex">
          {/* credit-card-rolodex-list */}
          <ul className="credit-card-rolodex-list" ref={this.myRef} style={{ marginTop: this.state.creditCardRolodexMarginTop }}>
            {/* credit-card-rolodex-item */}
            {this.state.rolodexCards.map((card, index) => {
              return (
                <Hammer
                  direction="DIRECTION_ALL"
                  key={index}
                  onSwipe={(evt) => {
                    this.onSwipe(evt);
                  }}
                >
                  <li
                    style={{
                      background: card.cardImagesUrl.background.includes("http")
                        ? "url(" + card.cardImagesUrl.background + ") no-repeat center center / cover"
                        : card.cardImagesUrl.background,
                      zIndex: card.rolodexLayout.zIndex,
                      top: card.rolodexLayout.top,
                      width: card.rolodexLayout.width,
                      display: this.hideCard(card.rolodexLayout.zIndex) ? "grid" : "none",
                    }}
                    className={`credit-card-rolodex-item ${card.class}`}
                  >
                    <div className={`details ${card.cardImagesUrl.backgroundBrightness === 1 ? "white" : "black"}`}>
                      <div className="last-4-digits">
                        <span className="number">{card.last4Digits}</span>
                        <span className="last-4-digits-mask">
                          <span className="circle"></span>
                          <span className="circle"></span>
                          <span className="circle"></span>
                          <span className="circle"></span>
                        </span>
                      </div>
                      <div className="name">{card.cardOwnerName}</div>
                    </div>
                    <div className="brand-club">
                      <div
                        className="brand"
                        style={{
                          backgroundImage: "url(" + card.cardImagesUrl.brandLogo + ")",
                        }}
                      ></div>
                      <div
                        className="club"
                        style={{
                          backgroundImage: "url(" + card.cardImagesUrl.clubLogo + ")",
                        }}
                      ></div>
                    </div>
                  </li>
                </Hammer>
              );
            })}
            {/* credit-card-rolodex-item */}
          </ul>
          {/* credit-card-rolodex-list */}
        </div>

        <div className="pagination">
          <button
            className="up"
            tooltip="כרטיס קודם"
            onClick={() => {
              this.onPagination("up");
            }}
          >
            <img src={upArrow} alt="" srcSet="" />
          </button>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/card/CardList.jsx